/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCarouselFill: {
  name: 'carousel-fill';
  data: string;
} = {
  name: 'carousel-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 .5a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V1a.5.5 0 0 0-.5-.5H5ZM12.5 4a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V4ZM1 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H1Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
